import logger from "@/core/logger"
import * as v from "valibot"
import { isError } from "./isError"
import { ValidationError } from "./error"

function getValidationMessage(context: string, error: unknown, data: unknown): string {
  let message = ""
  if (error instanceof v.ValiError) {
    message = JSON.stringify(v.flatten(error.issues).nested)
  } else {
    message = isError(error) ? error.message : String(error)
  }
  return `There are errors: ${message} in your ${context} payload: ${JSON.stringify(data)}`
}

export function createAssertFn<S extends v.GenericSchema>(context: string, schema: S) {
  return function validate(data: v.InferInput<S>) {
    try {
      v.parse(schema, data)
    } catch (e) {
      const error = new ValidationError(getValidationMessage(context, e, data))
      logger.warn(error)
      throw error
    }
  }
}

export function createValidateFn<S extends v.GenericSchema>(context: string, schema: S) {
  return function validate(data: v.InferInput<S>) {
    const result = v.safeParse(schema, data)
    if (!result.success) {
      const valiError = new v.ValiError(result.issues)
      const error = new ValidationError(getValidationMessage(context, valiError, data))
      logger.warn(error)
    }
    return result.success
  }
}

export function nullish<T extends v.GenericSchema>(schema: T) {
  return v.optional(v.nullish(schema))
}

export const numberOrString = v.union([v.number(), v.string()])

export const numberToString = v.transform((v: string | number) => (typeof v === "number" ? v.toString() : v))
